// extracted by mini-css-extract-plugin
export default {"content":"PageNotFound_content__qkBrm","num":"PageNotFound_num__TjPDb","text":"PageNotFound_text__8eWkN"};